import { FETCH_VIDEO_MANAGER_QUEUE, RETRY_VIDEO_MANAGER_QUEUE_ITEM } from "../actions";

const initialState = {
  videoQueue: [],
  retryVideoQueueItem: {},
  videoQueueError: null,
  retryVideoQueueItemError: null,
};

function videoManagerReducer(state = initialState, action) {
  let videoQueue, retryVideoQueueItem;

  switch (action.type) {
    case `${FETCH_VIDEO_MANAGER_QUEUE}_PENDING`:
    case `${RETRY_VIDEO_MANAGER_QUEUE_ITEM}_PENDING`:
      return { ...state, loading: false, videoQueueError: null, retryVideoQueueItemError: null };

    case `${FETCH_VIDEO_MANAGER_QUEUE}_FULFILLED`:
      videoQueue = action.payload.data;
      return { ...state, loading: false, videoQueue };
    case `${RETRY_VIDEO_MANAGER_QUEUE_ITEM}_FULFILLED`:
      retryVideoQueueItem = action.payload.data;
      return { ...state, loading: false, retryVideoQueueItem };

    case `${FETCH_VIDEO_MANAGER_QUEUE}_REJECTED`:
      return {
        ...state,
        loading: false,
        videoQueueError: action.payload.response.data,
        state: initialState,
      };
    case `${RETRY_VIDEO_MANAGER_QUEUE_ITEM}_REJECTED`:
      return {
        ...state,
        loading: false,
        retryVideoQueueItemError: action.payload.response.data,
        state: initialState,
      };

    default:
      return state;
  }
}

export default videoManagerReducer;
